export default __webpack_public_path__ + "static/media/menu_upgrade_vip.fe200852.svg";